<template>
  <aside
    class="sidebar"
    :class="{ expanded: isExpanded }"
    @mouseenter="isExpanded = true"
    @mouseleave="isExpanded = false"
  >
    <div
      class="service"
      :class="{ active: activeService === 'flights' }"
      @click="goTo('flights')"
    >
      <img src="@/assets/images/plane-white-last.svg" alt="Vuelos" />
      <span class="service-name">Vuelos</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'hotels' }"
      @click="goTo('hotels')"
    >
      <img src="@/assets/images/bed-white-last.svg" alt="Hoteles" />
      <span class="service-name">Hoteles</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'cars' }"
      @click="goTo('cars')"
    >
      <!-- Icono para la sección de Autos -->
      <img src="@/assets/images/car-white-last.svg" alt="Autos" />
      <span class="service-name">Autos</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'transfers' }"
      @click="goTo('transfers')"
    >
      <img src="@/assets/images/traslado-white-last.svg" alt="Traslados" />
      <span class="service-name">Traslados</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'lounges' }"
      @click="goTo('lounges')"
    >
      <img src="@/assets/images/vip-white-last.svg" alt="Salas VIP" />
      <span class="service-name">Salas VIP</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'assists' }"
      @click="goTo('assists')"
    >
      <img src="@/assets/images/assist-white.svg" alt="Asist Card" />
      <span class="service-name">Assist Card</span>
    </div>
    <hr />
    <div
      class="service"
      :class="{ active: activeService === 'shows' }"
      @click="goTo('shows')"
    >
      <img src="@/assets/images/espec-white-last.svg" alt="Espectáculos" />
      <span class="service-name">Espectáculos</span>
    </div>
    <hr />
  </aside>
</template>

<script>
export default {
  name: "SidebarComp",
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    activeService() {
      const routeName = (this.$route.name || "").toLowerCase();
      if (routeName.startsWith("flight")) return "flights";
      if (routeName.startsWith("hotel")) return "hotels";
      if (routeName.startsWith("car")) return "cars";
      if (routeName.startsWith("transfer")) return "transfers";
      if (routeName.startsWith("lounge")) return "lounges";
      if (routeName.startsWith("assist")) return "assists";
      if (routeName.startsWith("show")) return "shows";
      // Agrega aquí más servicios si es necesario
      return "";
    },
  },
  methods: {
    goTo(service) {
      this.$router.push(`/${service}`);
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.sidebar {
  /* Layering and positioning */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3; /* Capa más alta para estar siempre visible */

  /* Dimensions and appearance */
  width: 80px; /* Ancho inicial */
  height: 100vh;
  background-color: var(--color-acento-terciario); /* Example color */
  transition: width 0.3s ease-in-out; /* Transición para el ancho */
  overflow: hidden; /* Para que el texto no se salga al colapsar */

  /* Content alignment */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
}

.sidebar.expanded {
  width: 200px; /* Ancho expandido */
}

.service {
  display: flex;
  align-items: center;
  width: calc(100% - 16px); /* 100% - (8px margin * 2) */
  margin: 4px 8px;
  padding: 0 18px; /* (80px - 16px margin - 28px img) / 2 = 18px. Centra el icono. */
  box-sizing: border-box;
  cursor: pointer;
  height: 50px;
  transition: background-color 0.2s;
  border-radius: 6px; /* Bordes redondeados para el recuadro */
}

.service:hover,
.service.active {
  background-color: var(
    --color-acento-primario
  ); /* Color de hover solicitado */
}

.service img {
  width: 28px;
  height: 28px;
  flex-shrink: 0; /* Evita que el icono se encoja */
}

.service-name {
  margin-left: 20px;
  color: white;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  white-space: nowrap; /* Evita que el texto se parta */
}

.sidebar.expanded .service-name {
  opacity: 1;
  transition-delay: 0.1s; /* Pequeño retraso para que aparezca después de expandir */
}

/* Línea de separación entre servicios */
hr {
  width: 60%;
  border: 0;
  border-top: 1px solid var(--color-acento-secundario-suave); /* Color más sutil para la línea */
  margin: 10px 0; /* Reducimos el margen para compensar el del servicio */
  transition: width 0.3s ease-in-out;
}

.sidebar.expanded hr {
  width: 85%;
}

/* --- Responsive Design --- */
@media (max-width: 1024px) {
  .sidebar {
    display: none;
  }
}
</style>
